module.exports = __webpack_public_path__ + "img/b3d0af6.jpg";